import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=be15c17c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=be15c17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be15c17c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be15c17c')) {
      api.createRecord('be15c17c', component.options)
    } else {
      api.reload('be15c17c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=be15c17c&scoped=true&", function () {
      api.rerender('be15c17c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XDLlP5BRivlU/JS/comp/Voucher.vue"
export default component.exports